<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 548.291 548.291"
  style="enable-background: new 0 0 548.291 548.291"
  xml:space="preserve"
>
  <g>
    <path
      d="M295.028,261.379c-6.126,0-10.268,0.599-12.441,1.189v39.29c2.573,0.593,5.722,0.782,10.068,0.782
		c16,0,25.87-8.085,25.87-21.713C318.525,268.691,310.02,261.379,295.028,261.379z"
    />
    <path
      d="M411.333,261.783c-6.72,0-11.065,0.585-13.639,1.189v87.054c2.578,0.593,6.71,0.593,10.479,0.593
		c27.239,0.199,45.008-14.813,45.008-46.593C453.38,276.382,437.186,261.783,411.333,261.783z"
    />
    <path
      d="M486.201,196.124h-13.166V132.59c0-0.396-0.062-0.795-0.115-1.196c-0.021-2.523-0.825-5-2.552-6.963L364.657,3.677
		c-0.033-0.031-0.064-0.042-0.085-0.073c-0.63-0.707-1.364-1.292-2.143-1.795c-0.229-0.157-0.461-0.286-0.702-0.421
		c-0.672-0.366-1.387-0.671-2.121-0.892c-0.2-0.055-0.379-0.136-0.577-0.188C358.23,0.118,357.401,0,356.562,0H96.757
		C84.894,0,75.256,9.651,75.256,21.502v174.613H62.092c-16.971,0-30.732,13.756-30.732,30.733v159.812
		c0,16.968,13.761,30.731,30.732,30.731h13.164V526.79c0,11.854,9.638,21.501,21.501,21.501h354.776
		c11.853,0,21.501-9.647,21.501-21.501V417.392h13.166c16.966,0,30.729-13.764,30.729-30.731V226.854
		C516.93,209.872,503.167,196.124,486.201,196.124z M96.757,21.502h249.054v110.009c0,5.939,4.817,10.75,10.751,10.75h94.972v53.861
		H96.757V21.502z M348.33,280.135c0,13.039-4.342,24.089-12.241,31.602c-10.269,9.669-25.471,14.011-43.224,14.011
		c-3.958,0-7.513-0.2-10.278-0.593v47.586h-29.809V241.442c9.284-1.585,22.31-2.762,40.658-2.762
		c18.562,0,31.797,3.546,40.679,10.654C342.598,256.048,348.33,267.114,348.33,280.135z M67.36,239.67h32.177l10.068,54.885
		c2.96,15.795,5.724,32.956,7.9,46.384h0.399c2.171-14.404,5.323-30.404,8.669-46.783l11.273-54.488h31.974l10.665,56.064
		c2.96,15.6,5.128,29.815,7.104,44.62h0.389c1.971-14.805,4.935-30.399,7.704-46.196l10.855-54.488h30.593L202.787,372.73h-32.585
		l-11.245-57.251c-2.575-13.429-4.743-25.868-6.323-41.07h-0.386c-2.378,15.013-4.549,27.642-7.703,41.07l-12.643,57.251H98.931
		L67.36,239.67z M451.534,520.962H96.757v-103.57h354.776V520.962z M463.051,356.944c-14.011,11.645-35.339,17.161-61.398,17.161
		c-15.595,0-26.645-0.977-34.157-1.964V241.442c11.07-1.772,25.476-2.762,40.678-2.762c25.26,0,41.649,4.536,54.488,14.218
		c13.816,10.266,22.51,26.644,22.51,50.141C485.171,328.513,475.885,346.074,463.051,356.944z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
